import EmailAddressListContainer from './containers/EmailAddressListContainer'

export default EmailAddressListContainer
